import { FlowType } from '@ace-clublabs/common-membership-api-types';

export enum FlowContentName {
  ADOLabel = 'ADO_LABEL',
  ADODiscountedLabel = 'ADO_DISCOUNTED_LABEL',
  MDOLabel = 'MDO_LABEL',
  ContactType = 'CLUB_CONTACT_TYPE',
  ContactValue = 'CLUB_CONTACT_VALUE',
  BenefitSavingTotalClass = 'BENEFIT_SAVING_TOTAL_CLASS',
}

type TemporalObject = {
  [key in string]: {
    value: string | undefined;
    clubCode?: string | undefined;
  };
};

const convertFromArrayOfFlowsToObject = (flows: FlowContent[]) => {
  return flows.reduce((acc, item) => {
    acc[`${item.name}#${item.clubCode ? item.clubCode : ''}`] = {
      value: item.value,
      clubCode: item.clubCode,
    };
    return acc;
  }, {} as TemporalObject);
};

const convertObjectToArrayOfFlows = (object: TemporalObject): FlowContent[] => {
  let finalFlow: FlowContent[] = [];

  Object.entries(object).forEach(([key, value]) => {
    const segments = key.split('#');
    let flow: FlowContent = {
      name: segments[0] as FlowContentName,
      value: value?.value,
    };
    if (value.clubCode) {
      flow['clubCode'] = value.clubCode;
    }
    finalFlow.push(flow);
  });

  return finalFlow;
};

export const mergeWithRightOverride = (
  sharedContent: FlowContent[],
  overridingContent: FlowContent[]
): FlowContent[] => {
  const sharedContentObject: TemporalObject = convertFromArrayOfFlowsToObject(sharedContent);
  const overridingContentObject: TemporalObject = convertFromArrayOfFlowsToObject(overridingContent);
  const mergedObject: TemporalObject = { ...sharedContentObject, ...overridingContentObject };
  return convertObjectToArrayOfFlows(mergedObject);
};

export interface FlowContent {
  name: FlowContentName;
  value?: string;
  clubCode?: string;
}

// Shared flow
export const sharedContent: FlowContent[] = [
  {
    name: FlowContentName.ADOLabel,
    value: '/year',
  },
  {
    name: FlowContentName.ADODiscountedLabel,
    value: '/first year',
  },
  {
    name: FlowContentName.MDOLabel,
    value: '/month',
  },
  {
    name: FlowContentName.BenefitSavingTotalClass,
    value: 'benefit-saving-total',
  },
  {
    name: FlowContentName.ContactType,
    value: 'tel',
  },
];

//Major rocket
export const majorRocketContentOverride = [
  {
    name: FlowContentName.ADOLabel,
    value: '/first year',
  },
  {
    name: FlowContentName.BenefitSavingTotalClass,
    value: 'strikethrough benefit-saving-total',
  },
  {
    name: FlowContentName.ContactType,
    value: 'mailto',
  },
  {
    name: FlowContentName.ContactValue,
    value: 'Support@aaamembershipoffers.com',
  },
];
const majorRocketContent: FlowContent[] = mergeWithRightOverride(sharedContent, majorRocketContentOverride);

//T-mobile
export const tMobileContentOverride: FlowContent[] = [
  {
    name: FlowContentName.ADOLabel,
    value: '/first year',
  },
];
const tMobileContent: FlowContent[] = mergeWithRightOverride(sharedContent, tMobileContentOverride);

//New Join
const newJoinContent: FlowContent[] = [...sharedContent];

//Employee
const employeeContent: FlowContent[] = [...sharedContent];

//Gift
export const giftOverride: FlowContent[] = [
  {
    name: FlowContentName.ADOLabel,
    value: '/first year',
  },
];
const giftContent: FlowContent[] = mergeWithRightOverride(sharedContent, giftOverride);

//Groupon
export const grouponContentOverride = [
  {
    name: FlowContentName.ADOLabel,
    value: '/first year',
  },
  {
    name: FlowContentName.BenefitSavingTotalClass,
    value: 'strikethrough benefit-saving-total',
  },
];
const grouponContent: FlowContent[] = mergeWithRightOverride(sharedContent, grouponContentOverride);

const contents: Partial<Record<FlowType, FlowContent[]>> = {
  [FlowType.MAJOR_ROCKET]: majorRocketContent,
  [FlowType.B2B_MAJOR_ROCKET]: majorRocketContent,
  [FlowType.GROUPON]: grouponContent,
  [FlowType.NEW_JOIN]: newJoinContent,
  [FlowType.REJOIN]: newJoinContent,
  [FlowType.EMPLOYEE]: employeeContent,
  [FlowType.T_MOBILE]: tMobileContent,
  [FlowType.GIFT]: giftContent,
};

export const getFlowContent = (name: string, flowType: FlowType | undefined | null, clubCode?: string): string => {
  if (!flowType) {
    return '';
  }

  let item: any = contents[flowType]?.find((i) => i.name === name);

  if (clubCode) {
    const clubItem = contents[flowType]?.find((i) => i.name === name && i.clubCode === clubCode);
    item = clubItem ?? item;
  }

  if (item == null || item == undefined || item.value == null || item.value == undefined) {
    return '';
  }

  return item?.value;
};
